module.exports = __webpack_public_path__ + "static/lobster-writer-7753c9e33e9432eafe9cc274d2ef3bbf.png";